<template>
  <div class="news_p">
    <headd></headd>

    <div class="news container">
      <div class="new_type">
        <div
          class="type_item"
          v-for="(item, index) in newstypelist"
          :key="item.slug"
          :data-index="index"
          :data-title="item.slug"
          @click="selecttype"
          :class="{ active: isChange == index }"
        >
          {{ item.title }}
        </div>
      </div>
      <newsItem @itemClick="goDetail" :list="newsList"></newsItem>
      <div class="gomore" @click="morelist" v-show="!flag">加载更多</div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import newsItem from "../../components/news-item";
import headd from "@/components/head";
import foot from "@/components/foot";

import { getzixuncate, getzixun } from "../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      newsList: [],
      newstypelist: [],
      pageindex: 1,
      flag: false,
      dtype: "",
      isChange: "-1"
    };
  },
  mounted() {
    this.getNewsType();
    this.getNews();
  },
  methods: {
    async getNews() {
      var _slef = this;
      var data = {
        dtype: _slef.dtype,
        page: _slef.pageindex,
        limit: 50
      };

      const res = await getzixun(data);
      _slef.newsList = _slef.newsList.concat(res.data.data.zixun);

      if (res.data.data.zixun.length < 50) {
        _slef.flag = true;
      }
    },
    async getNewsType() {
      var newstypelist = await getzixuncate();
      this.newstypelist = newstypelist.data.data.zixuncate;

      this.newstypelist = [
        {
          slug: "",
          title: "全部类型"
        },
        ...newstypelist.data.data.zixuncate
      ];
    },
    goDetail(id, is_ad) {
      if (is_ad === 1) return false;
      this.$router.push({
        name: "newsdetail",
        params: {
          id: id
        }
      });
      //this.$router.push("newsdetail");
      //this.$store.commit("setParameters", { key: "id", value: id });
      //sessionStorage.setItem("id", id);
    },
    selecttype(e) {
      var _slef = this;
      var index = e.currentTarget.dataset.index;
      var type = e.currentTarget.dataset.title;
      _slef.pageindex = 1;
      if (index != this.isChange) {
        this.isChange = index;
        _slef.dtype = type;
      } else {
        this.isChange = -1; //不注释则可以点击取消，注释之后点击就不再取消
        _slef.dtype = "";
      }
      this.newsList = [];
      this.getNews();
    },
    morelist() {
      if (!this.flag) {
        this.pageindex++;
        this.getNews();
      }
    }
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    newsItem,
    headd,
    foot
  },
  onLoad(options) {
    if (options.dtype) {
      this.dtype = options.dtype;
    }
    this.$logindex();
  },
  onShow() {
    this.newsList = [];
    this.pageindex = 1;
    (this.flag = false), this.getNews();
    this.getNewsType();
  },

  onPullDownRefresh() {
    console.log("下拉刷新了");
    this.pageindex = 1;
    this.newsList = [];
    this.flag = false;
    setTimeout(() => {
      this.getNews(() => {
        uni.stopPullDownRefresh();
      });
    }, 1000);
  }
};
</script>

<style lang="less">
.news_p {
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
  }

  .news {
    flex-direction: column;
    @media (max-width: 991px) {
      padding: 0;
    }

    margin: auto;

    .new_type {
      width: 100%;
      margin: 0.32rem 0 0 0;
      flex-wrap: wrap;
      justify-content: flex-start;
      display: flex;

      .type_item {
        cursor: pointer;
        width: 1.28rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.18rem;
        color: #8d8e99;
        background-color: none;
        border-radius: 0.25rem;
        text-align: center;
        justify-content: center;
        @media (max-width: 991px) {
          font-size: 0.3rem;
          width: 25%;
          margin-bottom: 0.2rem;
        }
      }

      .type_item.active {
        color: #fff;
        background-color: #1395ff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/news/news.vue